<template>
    <RightDrawer title="拜访详情" :visible.sync="visible">
        	<template slot="content">
        		<div v-for="(item, index) in locus_list" :key="index">
        			<div class="drawer_title" style>
        			{{item.type_name}}
        			</div>
        			<a-descriptions>
        				<a-descriptions-item  :span="3" label="操作人">{{item.operation_name}}</a-descriptions-item>
        				<a-descriptions-item :span="3" label="操作时间">{{item.create_time}}</a-descriptions-item>
        				<a-descriptions-item  :span="3" label="操作内容">{{item.content}}</a-descriptions-item>
        			</a-descriptions>
        		</div>
        	</template>
    </RightDrawer>
</template>

<script>
let type_list = [
    {
        key: 0,
        value: '计划拜访'
    },
    {
        key: 1,
        value: '临时拜访'
    },
    {
        key: 2,
        value: '指定拜访'
    },
    {
        key: 3,
        value: '巡查'
    },
];
import { getCustomerChangeRecord } from "@/api/customer";
import RightDrawer from "@/components/RightDrawer";

export default {
	components:{
		RightDrawer,
	},
	props:{
		
	},
    data() {
        return {
			visible:false,
			locus_list:[]
        }
    },
    methods: {
        
        get_details(item, index) {
            getCustomerChangeRecord({
                data: {
                    customer_id: item.id
                }
            }).then(res => {
				this.locus_list = res.data.list;
				this.visible = true;
            })
        },
    }

}
</script>
<style>
	.drawer_title {
		padding: 15px 0;
		font-size:15px;
		font-weight: bold;
		color:#397dee;
	}
</style>